function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m374.996094 205.996094h-262.730469v-115.996094c0-16.570312 13.433594-30 30-30h105.464844c16.566406 0 30 13.429688 30 30v31.664062c0 11.046876 8.953125 20 20 20h20c11.042969 0 20-8.953124 20-20v-41.664062c0-44.183594-35.820313-80-80-80h-125.464844c-44.179687 0-80 35.816406-80 80v125.996094h-37.265625c-8.285156 0-15 6.714844-15 15v276.003906c0 8.285156 6.714844 15 15 15h359.996094c8.285156 0 15-6.714844 15-15v-276.003906c0-8.285156-6.714844-15-15-15zm-150 157.894531v62.234375c0 5.523438-4.476563 10-10 10h-39.996094c-5.523438 0-10-4.476562-10-10v-62.234375c-10.75-9.089844-17.324219-22.960937-16.414062-38.335937 1.398437-23.675782 20.804687-42.6875 44.5-43.636719 26.550781-1.0625 48.410156 20.144531 48.410156 46.460937 0 14.242188-6.410156 26.984375-16.5 35.511719zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m202.390625 96.144531c-5.855469 5.859375-5.855469 15.355469 0 21.214844l15.25 15.25c2.929687 2.925781 6.769531 4.390625 10.605469 4.390625 3.839844 0 7.679687-1.460938 10.609375-4.390625 5.855469-5.859375 5.855469-15.355469 0-21.214844l-15.25-15.25c-5.859375-5.855469-15.355469-5.855469-21.214844 0zm0 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m413.582031 96.144531c-5.855469-5.855469-15.355469-5.855469-21.210937 0l-15.25 15.25c-5.855469 5.855469-5.855469 15.355469 0 21.210938 2.929687 2.929687 6.769531 4.394531 10.605468 4.394531 3.839844 0 7.679688-1.464844 10.609376-4.394531l15.246093-15.246094c5.859375-5.859375 5.859375-15.355469 0-21.214844zm0 0"
});

var SvgUnlocked = function SvgUnlocked(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-47 0 512 512",
    width: "512pt",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUnlocked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unlocked.e3a630b0.svg";
export { ForwardRef as ReactComponent };